import type { EmbarcacoesColumnKey } from "@/modules/embarcacoes";
export const EMBARCACOES_TITLE = "Embarcações";
export const EMBARCACOES_SEARCH_PLACEHOLDER = "Buscar Embarcação";
export const EMBARCACOES_SEARCH_PLACEHOLDER_MOBILE = "Buscar Embarcação...";

/** Mesmo corte do mobile de Obras (`$ds-breakpoint-md`). */
export const EMBARCACOES_MOBILE_QUERY = "(max-width: 768px)";

/** Nome base do arquivo exportado quando o serviço não informa um. */
export const EMBARCACOES_EXPORT_FILE_NAME = "embarcacoes";
export const EMBARCACOES_EXPORT_LIST_NAME = "embarcações";

/** O estado "sem permissão" vem do `403` devolvido pela API (privilégio `hub.embarcacao:visualizar`). */
export const EMBARCACOES_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar as embarcações do Hub.";
export const EMBARCACOES_ERROR_MESSAGE = "Não foi possível carregar as embarcações.";

export const EMBARCACOES_LOADING_LABEL = "Carregando embarcações...";
export const EMBARCACOES_ROWS_PER_PAGE_LABEL = "Embarcações por página";
export const EMBARCACOES_TABLE_LABEL = "Embarcações";

export type { EmbarcacoesColumnKey };

/** Colunas de dado do Figma 7945:222883, na ordem da tabela; a lupa fecha a linha. */
export const EMBARCACOES_COLUMNS = [
  { key: "acronimo", header: "Acrônimo" },
  { key: "nome", header: "Embarcação" },
  { key: "tipo", header: "Tipo" },
  { key: "situacao", header: "Situação" },
] as const;

export const EMBARCACOES_ACTIONS_KEY = "acoes";

/** Todas as colunas, na ordem da tabela: com 6 ou menos a seção de colunas do Configurações da Tabela não aparece. */
export const EMBARCACOES_ALL_COLUMNS: readonly EmbarcacoesColumnKey[] = [
  ...EMBARCACOES_COLUMNS.map(({ key }) => key),
  EMBARCACOES_ACTIONS_KEY,
];

/** Larguras do Figma desktop (7945:222883: 135, 290, 315, 168 e 52); no mobile a tabela rola na horizontal. */
export const EMBARCACOES_COLUMN_WIDTHS_REM: Record<EmbarcacoesColumnKey, number> = {
  acronimo: 8.4375,
  nome: 18.125,
  tipo: 19.6875,
  situacao: 10.5,
  acoes: 3.25,
};

/** Mobile (Figma 7945:219730 mobile): Acrônimo de 96 e Embarcação de 181; as demais seguem o desktop. */
export const EMBARCACOES_MOBILE_COLUMN_WIDTHS_REM: Partial<Record<EmbarcacoesColumnKey, number>> = {
  acronimo: 6,
  nome: 11.3125,
};

/** Escopo dos filtros salvos de Embarcações no armazenamento (separado das demais telas). */
export const SAVED_FILTERS_SCREEN = "embarcacoes";
